import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

/**
 * Marks a part as belonging to a confidential, customer-owned package family. Wears exactly the
 * chip the model module chip's context menu already uses for this state, so the same fact reads
 * the same wherever it is surfaced.
 *
 * @returns The badge element.
 */
export function ConfidentialDatasheetBadge() {
	return (
		<Tooltip title='This part is from a confidential, customer-owned package family'>
			<Chip variant='outlined' color='primary' label='Confidential' />
		</Tooltip>
	);
}
